module.exports = __webpack_public_path__ + "static/media/polished.fef153ea.png";